<template lang="pug">
v-dialog(
v-model="show",
width="auto",
max-width="700px",
persistent,
v-if="item"
)
    form(
        @submit.prevent="validate('item_variacao')",
        data-vv-name="item_variacao",
        style="width: 100%"
    )
        v-card
            v-card-title
                span.title {{ item.nome ? 'Editar Variação' : 'Cadastrar Variação'}}
            v-card-text
                v-layout(row, wrap)
                    v-flex.xs12.pb-0
                        v-text-field.mb-1.pb-0.inputDefault(
                            color="gray",
                            label="Nome",
                            required,
                            v-validate="'required'",
                            :error-messages="errors.collect('nome')",
                            data-vv-name="nome",
                            type="text",
                            v-model="item.nome",
                            autofocus,
                            :hide-details="false",
                            outline
                        )
                v-layout(row, wrap)
                    v-flex.xs12.md6.sm12.my-2.pr-1
                        v-textarea.inputDefault.inputDescricao(
                            color="gray",
                            label="Descrição",
                            type="text",
                            v-model="item.descricao",
                            :hide-details="true",
                            outline
                        )
                    v-flex.xs12.md6.pt-0.my-2.pl-1
                        v-flex.xs12.md12.text-xs-center.br-10(:class="{'loadingImagem': loading}", style="border:1px solid rgba(0,0,0,0.2); background-color: #f6f6f6; min-height:268px;aspect-ratio: 1/1;")
                            v-layout(row, wrap, align-center, style="height: 100%;")
                                v-flex.md12.pa-0(style="height: 100%;")
                                    div.d-flex.justify-center(
                                        v-if="!imagem",
                                        style="position: relative; height: 100%;"
                                    )
                                        crop-image.seletorImagem(
                                            :defaultImage.sync="imagem",
                                            :height="500",
                                            :width="500",
                                            :circle="false",
                                        )
                                    div(v-else,style="position: relative; aspect-ratio: 1/1;")
                                        img.md6.xs6.posicaoImagem(
                                            :src="imagem.indexOf('data:') > -1 ? imagem : `${urlImagem}/item/${imagem}`",
                                            style="border-radius: 5px;max-width: 100%;max-height: 100%;",
                                        )
                                        v-tooltip.iconDeletar(top)
                                            v-btn(icon, @click="fakeDelImage(item)", v-show="!loading", slot="activator")
                                                v-icon(color="red") delete
                                            span Remover Imagem
                v-layout(row, wrap)
                    v-flex.xs12.pt-2
                        v-text-field.inputDefault(
                            color="gray",
                            label="Código PDV",
                            type="text",
                            v-model="item.pdv",
                            outline,
                        )
                v-layout(row, wrap)
                    v-flex.xs12.pt-2
                        v-currency-field.inputDefault(
                            v-if="item.mod_preco !== 6",
                            label="Preço",
                            color="gray",
                            required,
                            name="preco",
                            v-validate="'required|min_value:0'",
                            :error-messages="errors.collect('preco')",
                            data-vv-name="preco",
                            data-vv-as="preço",
                            type="text",
                            v-model="item.preco",
                            v-bind="currency_config",
                            outline
                        )
                        v-text-field(
                          v-if="item.mod_preco === 6",
                          label="Valor Percentual",
                          color="gray",
                          required,
                          name="preco",
                          v-validate="'required|min_value:0|max_value:100'",
                          :error-messages="errors.collect('preco')",
                          data-vv-name="preco",
                          data-vv-as="preco",
                          type="number",
                          v-bind="percentage_config",
                          v-model="item.preco",
                          outline
                        )
                    v-flex.md12.xs12.pt-0(v-bind:class="[$root.mobile ? 'areaAbtnsComplementos' : '']")
                        v-card-actions.right(v-if="($root.user.permissao_cardapio)")
                            v-spacer(v-if="!$root.mobile")
                            v-btn.btnSalvar(
                                depressed,
                                color="primary"
                                type="submit",
                                :loading="loading",
                                :disabled="loading"
                                ) Salvar
                        v-btn.right(
                            type="button",
                            flat,
                            color="gray darken-1",
                            @click.native="show = false; item = null"
                        ) Fechar
</template>

<script>
import CropImage from "@/components/CropImage";

export default {
    $_veeValidate: {
        validator: "new",
    },
    components: {
        CropImage,
    },
    data: () => ({
        show: false,
        loading: false,
        currency_config: {
            decimal: ",",
            thousands: ".",
            prefix: "R$ ",
            suffix: "",
            precision: 2,
            masked: false,
            min: 0,
        },
        percentage_config: {
          decimal: ",",
          thousands: ".",
          prefix: "%",
          precision: 0,
        },
        item: null,
        imagem: null,
        delAfterSave: false,
        imagemToDelete: null,
        categoria: null
    }),
    mounted() { },
    computed: {
      urlImagem(){
        return process.env.VUE_APP_IMAGE_URL;
      }
    },
    methods: {
        delAfterSaveFunc(bool){
          this.delAfterSave = bool;
        },
        open(item, categoria) {
            this.show = true;
            this.categoria = categoria;
            this.item = item ?
                _.cloneDeep(item)
                : {
                    categoria_id: this.categoria.id,
                    disponibilidade_diaria: "0,1,2,3,4,5,6",
                    preco: 0,
                    promocional: 0,
                    preco_promocional: 0,
                    preco_variavao: 0,
                    indice:
                        this.categoria && this.categoria.allItens
                            ? parseInt(this.categoria.allItens.length)
                            : 0,
                    ativo: 1,
                    data_inicio: null,
                    data_fim: null,
                    catalogo_id: this.categoria.catalogo_id,
                    versao: 0,
                    mod_preco: this.categoria.mod_preco,
                    min: this.categoria.min,
                    max: this.categoria.max,
                };

            if (this.item.mod_preco === 6 && this.item.preco <= 1) {
              this.item.preco *= 100;
              this.precoMultiplicado = true;
            }
            this.imagem = item.imagem;
        },
        async validate() {
            try {
                this.loading = true;

                const result = await this.$validator.validateAll('item_variacao');

                if (!result) throw "Preencha todos os campos corretamente!";

                else if(this.item.preco < 0) {
                  throw "O preço não pode ser um valor negativo."
                }


                if (this.item.mod_preco == 6 && this.item.preco == 0) {
                  this.$validator.errors.add({
                    field: 'preco',
                    msg: 'O valor percentual não pode ser 0!'
                  });
                  this.loading = false;
                  return false;
                }

                if (this.item.mod_preco == 6 && this.item.preco > 100) {
                  this.$validator.errors.add({
                    field: 'preco',
                    msg: 'O valor percentual deve ser menor ou igual a 100%!'
                  });
                  this.loading = false;""
                  return false;
                }

                if (this.item && this.item.nome && this.item.nome.length > 100) {
                  this.$validator.errors.add({
                    field: 'nome',
                        msg: 'O nome da item deve ter menos de 100 caracteres!'
                    });
                  this.loading = false;
                  return false;
                }
                await this.save(this.item);

                this.loading = false;
                this.show = false;
            } catch (error) {
                window.getApp.$emit("APP_ALERT", { color: "red", text: error });
                this.loading = false;
            }
        },
        async save(item) {
            try {
                if (item.mod_preco == 6) {
                  item.preco *= 0.01
                }

                if (this.imagem && this.imagem.indexOf("data:") > -1) {
                    const filename = await this.uploadImagem(this.imagem);
                    item.imagem = filename;
                    this.imagem = filename;
                } else if (this.delAfterSave) {
                    await this.removeFile()
                }
                this.delAfterSave = false;

                const response = await this.$axios[item.id ? 'put' : 'post']("/catalogo/item", item);

                this.categoria.allItens = this.categoria.allItens || [];
                if (this.categoria.id == item.categoria_id) {
                    if (item.id)
                        this.categoria.allItens.map((item) => {
                            if (item.id == response.data.id)
                                item = _.merge(item, response.data);
                        });
                    else {
                        item.id = response.data.id;
                        this.categoria.allItens.push(response.data);
                    }
                }

                this.loading = false;
                this.$validator.reset();

                this.$emit('refresh-variacoes', this.categoria);

                window.getApp.$emit("APP_ALERT", {
                    color: "success",
                    text: "Complemento salvo com sucesso!",
                });

            } catch (error) {
                console.log(error)
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao salvar a categoria. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                this.loading = false;
            }
        },
        fakeDelImage(item){
          this.imagemToDelete = this.imagem;
          item.imagem = null;
          this.imagem = null;
          this.delAfterSave = true;
        },
        async removeFile() {
            if (this.imagem && this.imagem.indexOf("data:") > -1) {
                this.imagem = null;
            } else if (this.imagemToDelete) {
                await this.deleteImagem(this.imagemToDelete);
                this.imagemToDelete = null;
            }
        },
        async uploadImagem(imagem) {
            try {
                this.loading = true;
                if(this.delAfterSave) {
                  await this.removeFile();
                }
                const blob = this.$root.b64toBlob(imagem);
                const formData = new FormData();
                formData.append("file", blob, "imagem.jpg");
                const response = await this.$axios.post(
                    "/catalogo/item/imagem",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            folder: "item",
                            filemethod: "crop",
                        },
                    }
                );
                this.loading = false;
                this.$emit('change-travaclose', false);
                return response.data.file.filename;
            } catch (error) {
                this.loading = false;
                window.getApp.$emit("APP_ALERT", {
                    color: "red",
                    text: "Ocorreu um erro ao salvar a imagem. Tente novamente!",
                });
            }
        },
        async deleteImagem(imagem) {
            try {
                this.loading = true;
                const response = await this.$axios.delete("/catalogo/item/imagem", {
                    params: { id: this.item.id, imagem },
                });
                this.imagem = null;
                this.item.imagem = null;
                this.loading = false;
                this.$emit('change-travaclose', false);
            } catch (error) {

                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao remover a imagem. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss">
.inputDefault .v-input__control .v-input__slot{
    background-color: #f6f6f6!important;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, .15)!important;
}

.inputDefault.v-input.v-input--is-focused .v-input__control .v-input__slot{
    border: 1px solid #1d9a5a !important;
}
</style>
<style scoped>
.areaAbtnsComplementos{
    padding: 0 !important;
    justify-content: flex-start;
    display: flex;
    flex-flow:column wrap;
    align-content: stretch;
    align-items: stretch;
}
.btnSalvar{
    width: 100%;
    border-radius: 5px !important;
    color:#fff;
    font-weight: 600;
}
.loadingImagem{
  background: repeating-linear-gradient(45deg,#edfcf3,#edfcf3 5%,#d3f8df 5%,#d3f8df 10%);
  background-size: 100px 100px;
  animation: listras 6s linear infinite;
}
.seletorImagem{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.posicaoImagem{
    width: 100%;
    height: 100%;
    border-radius: 10px;
    object-position: center center;
    object-fit: cover;
}
.iconDeletar{
    position: absolute;
    top: 20px;
    left: 95%;
    transform: translate(-50%, -50%);
    z-index:15;
}
</style>
